export const fieldsTranslationsIt = {
  'fields-parameters.navbar.services.title': 'Servizi',
  'fields-parameters.title': 'Parametri delle parcelle',
  'fields-parameters.services.table.title': 'Parcelle',
  'service.field_parameters.column.farmer_name.label': 'Azienda agricola',
  'service.field_parameters.column.field_number.label': 'Numero di parcelle',
  'service.field_parameters.column.total_area.label': 'Superficie totale (ha)',
  'service.field_parameters.detail_panel.column.field_name.label': 'Nome della parcella',
  'service.field_parameters.detail_panel.column.area.label': 'Superficie (ha)',
  'service.field_parameters.detail_panel.column.service.label': 'Servizio',
  'service.field_parameters.detail_panel.column.crop.label': 'Coltura',
  'service.field_parameters.detail_panel.column.subscription.label': 'Abbonamento',
  'service.field_parameters.detail_panel.column.subscription.active.label': 'Attivo',
  'service.field_parameters.detail_panel.column.subscription.no_subscription.label': 'Nessun abbonamento',
  'service.field_parameters.detail_panel.column.service.button.parameter.label': 'Parametri',
  'irrigation_field_service_parameters.button.undo.label': 'Annulla modifiche',
  'irrigation_field_service_parameters.button.save.label': 'Salva modifiche',
  'irrigation_field_service_parameters.multiple_edition.button.apply.label': 'Applica',
  'irrigation_field_service_parameters.multiple_edition.button.clear.label': 'Cancella',
  'irrigation_field_service_parameters.multiple_edition.title.label': 'Modifica di più parcelle',
  'irrigation_field_service_parameters.multiple_edition.info.setp1': '1- Compilare i campi da applicare a più parcelle',
  'irrigation_field_service_parameters.multiple_edition.info.setp2':
    '2- Selezionare le parcelle a cui si desidera applicare i parametri',
  'irrigation_field_service_parameters.multiple_edition.info.setp3':
    '3- Confermare cliccando sul pulsante applica (Attenzione: potrebbero apparire errori)',
  'irrigation_field_service_parameters.multiple_edition.info.setp4':
    '4- Salvare per applicare il proprio aggiornamento',
  'irrigation_field_service_parameters.table.Column.farmer_name.label': 'Azienda agricola',
  'irrigation_field_service_parameters.table.Column.field_number.label': 'Numero di parcelle',
  'irrigation_field_service_parameters.table.Column.total_area.label': 'Superficie totale (ha)',
  'irrigation_field_service_parameters.table.detail_panel.column.field.label': 'Parcella',
  'irrigation_field_service_parameters.table.detail_panel.column.soil.label': 'Suolo',
  'irrigation_field_service_parameters.table.detail_panel.column.weather_station.label': 'Stazione meteorologica',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_management.label': 'Gestione irrigazione',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_threshold.label': 'Soglia di irrigazione',
  'irrigation_field_service_parameters.table.detail_panel.column.assolment.label': 'Avvicendamento colturale',
  'fields-parameters.dialog.error.title': 'Errore durante il salvataggio',
  'fields-parameters.dialog.error.legend': 'Alcune delle modifiche hanno riscontrato errori e non sono state salvate.',
  'fields-parameters.dialog.error.contact':
    "Se il problema persiste, si prega di inviare questi errori al nostro servizio di supporto all'indirizzo",
};
